import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PercentProps = IconComponentBaseProps;

export const Percent = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PercentProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7357_4572"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7357_4572)">
        <path
          d="M7.6635 10.8172C6.78983 10.8172 6.04417 10.5084 5.4265 9.89074C4.80883 9.27324 4.5 8.52758 4.5 7.65374C4.5 6.78008 4.80883 6.03441 5.4265 5.41674C6.04417 4.79924 6.78983 4.49049 7.6635 4.49049C8.53717 4.49049 9.28283 4.79924 9.9005 5.41674C10.5182 6.03441 10.827 6.78008 10.827 7.65374C10.827 8.52758 10.5182 9.27324 9.9005 9.89074C9.28283 10.5084 8.53717 10.8172 7.6635 10.8172ZM7.663 9.31724C8.12483 9.31724 8.51758 9.15558 8.84125 8.83224C9.16508 8.50891 9.327 8.11633 9.327 7.65449C9.327 7.19249 9.16533 6.79966 8.842 6.47599C8.51867 6.15233 8.126 5.99049 7.664 5.99049C7.20217 5.99049 6.80933 6.15216 6.4855 6.47549C6.16183 6.79883 6 7.19141 6 7.65324C6 8.11524 6.16167 8.50808 6.485 8.83174C6.80833 9.15541 7.201 9.31724 7.663 9.31724ZM16.3462 19.5C15.4724 19.5 14.7268 19.1912 14.1093 18.5735C13.4916 17.9558 13.1827 17.2102 13.1827 16.3365C13.1827 15.4628 13.4916 14.7172 14.1093 14.0995C14.7268 13.4818 15.4724 13.173 16.3462 13.173C17.2199 13.173 17.9656 13.4818 18.5833 14.0995C19.2008 14.7172 19.5095 15.4628 19.5095 16.3365C19.5095 17.2102 19.2008 17.9558 18.5833 18.5735C17.9656 19.1912 17.2199 19.5 16.3462 19.5ZM16.3455 18C16.8075 18 17.2003 17.8383 17.524 17.515C17.8477 17.1917 18.0095 16.799 18.0095 16.337C18.0095 15.8752 17.8478 15.4824 17.5245 15.1587C17.2012 14.8349 16.8086 14.673 16.3468 14.673C15.8848 14.673 15.4919 14.8347 15.1683 15.158C14.8446 15.4813 14.6827 15.874 14.6827 16.336C14.6827 16.7978 14.8444 17.1907 15.1678 17.5145C15.4911 17.8382 15.8837 18 16.3455 18ZM5.123 18.877C4.98467 18.7385 4.9155 18.5639 4.9155 18.3532C4.9155 18.1426 4.98467 17.9691 5.123 17.8327L17.852 5.10399C17.9903 4.96549 18.1628 4.89783 18.3693 4.90099C18.5756 4.90416 18.748 4.97499 18.8865 5.11349C19.025 5.25199 19.0943 5.42658 19.0943 5.63724C19.0943 5.84791 19.025 6.02141 18.8865 6.15774L6.15775 18.8865C6.01925 19.025 5.84683 19.0927 5.6405 19.0895C5.434 19.0862 5.2615 19.0153 5.123 18.877Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
